module.exports = __webpack_public_path__ + "assets/img/gd2.b6fd74aa.jpg";